const vars = {
  boxShadow: {
    overlayMenu: '0 2px 3px 0 rgba(0, 0, 0, 0.3)',
    xs: '0 4px 4px 0 rgba(0, 0, 0, 0.1)',
  },
  borderRadius: {
    default: '5px',
  },
  newColor: {
    darkGS1: '#1D2226',
    darkGS2: '#586874',
    darkGS3: '#A2AFB8',
    lightGS1: '#D6DEEA',
    lightGS2: '#F5F7FA',
    white: '#FFFFFF',
    black: '#000000',
    blackTransparent: 'rgba(0, 0, 0, 0.75)',
    blue1: '#00469C',
    blue2: '#0067E5',
    blue3: '#4C9DFF',
    blue4: '#CCE3FF',
    purple1: '#5600C0',
    purple2: '#8019FF',
    purple3: '#9C4CFF',
    purple4: '#E0C7FF',
    gold1: '#E49600',
    gold2: '#FFB21F',
    gold3: '#FFC557',
    gold4: '#FFECC7',
    green1: ' #1F7A3F',
    green2: '#27964D',
    green3: '#71DA96',
    green4: '#CEF2DB',
    orange1: '#CC6200',
    orange2: '#FF7C02',
    orange3: '#FF9533',
    red1: '#8F001A',
    red2: '#BD0023',
    red3: '#FF002F',
    red4: '#FF99AC',
  },
  color: {
    midnight: '#1A1D1F',
    lightBlue: '#0B7ABF',
    lightGreen: '#D7F8E7',
    pink: '#E3176C',
    white: '#ffffff',
    green: '#1C9943',
    gold: '#E6A102',
    strawberry: '#D9092F',
    purple: '#6702CC',
    grey1: '#F5F9FC',
    grey2: '#DCE5EB',
    grey3: '#93ABBC',
    grey4: '#647079',
    grey5: '#2A2f33',
    black: '#000000',
    red: '#BE0023',
    blue: '#034999',
    orange: '#F27900',
  },
  transition: {
    default: 'all 0.2s ease-in-out',
  },
  form: {
    item: {
      borderWidth: '2px',
      margin: '0 0 30px 0',
    },
  },
  newForm: {
    item: {
      borderWidth: '2px',
      margin: '0 0 24px 0',
    },
  },
  breakPoints: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
};

export default vars;
